import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/production/$productionId/_layout/value/')({});